/** Arabic harakat, Quranic marks and the tatweel (kashida): typed or not, they never decide whether a menu label matches. */
const ARABIC_MARKS = /[ؐ-ًؚ-ٰٟۖ-ۭـ]/g;
/** Latin accents left over after decomposition ("é" -> "e"). */
const LATIN_ACCENTS = /[̀-ͯ]/g;

/**
 * The form a menu label and what the user typed are both reduced to before they are compared (the quick search of the sidebar): case folded,
 * diacritics dropped, and the Arabic letter variants that people type interchangeably made one letter - alef with hamza or madda (أ إ آ ٱ) -> ا,
 * teh marbuta (ة) -> ه, alef maksura (ى) -> ي. Symmetric on purpose: the same function runs on both sides, so "اداره" finds "الإدارة".
 */
export function normalizeSearchText(text: string): string {
  return text
    .normalize('NFD')
    .replace(ARABIC_MARKS, '')
    .replace(LATIN_ACCENTS, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** True when the label contains the query after both are normalized; an empty query matches everything. */
export function labelMatchesQuery(label: string, query: string): boolean {
  const needle = normalizeSearchText(query);
  return needle === '' || normalizeSearchText(label).includes(needle);
}
